export default theme => ({
  subform: {
    width: "95%",
  },
});
